import { LeaderboardMeta, LeaderboardRankings } from 'types/leaderboard';
import axios from 'axios';
import { PublicUser } from 'types/user';
import { getTokenString } from 'actions/auth';

export const fetchLeaderboardRankings = async (
  id: string,
  offset: number,
  limit: number,
  tags: string[],
  mergedResults: boolean = false,
  mergedIds: number[] = []
): Promise<LeaderboardRankings> => {
  let mergedRes = '';
  if (mergedResults) {
    mergedRes = 'mergedResults=true';
  }
  let res = await axios.get(
    `${
      process.env.REACT_APP_API
    }/v1/challenges/${id}/leaderboard?offset=${offset}&limit=${limit}&status=complete&tags=${tags}&${mergedRes}&mergedIds=[${mergedIds.join(
      ','
    )}]`
  );
  let data: LeaderboardRankings = res.data;

  // const idToUserMap: Record<string, PublicUser> = {};
  // const promises: Promise<PublicUser>[] = [];
  // const ids: string[] = [];
  // for (const d of data.entries) {
  //   if (idToUserMap[d.userId] === undefined) {
  //     ids.push(d.userId);
  //     idToUserMap[d.userId] = {
  //       name: '',
  //       challenges: [],
  //       id: '',
  //       role: '',
  //     };
  //   }
  // }
  // for (const id of ids) {
  //   promises.push(
  //     axios.get(`${process.env.REACT_APP_API}/v1/users/${id}`).then((res) => {
  //       idToUserMap[id] = res.data;
  //       return res.data;
  //     })
  //   );
  // }
  // await Promise.all(promises);
  // data.entries = data.entries.map((d) => {
  //   return { ...d, username: idToUserMap[d.userId].name };
  // });
  return data;
};

export const fetchChallenge = async (id: string) => {
  let res = await axios.get(`${process.env.REACT_APP_API}/v1/challenges/${id}`);
  return res.data;
};

export const fetchActiveLeaderboards = async (
  offset: number = 0,
  limit: number = 0
) => {
  let tokenStr = getTokenString();
  let res = await axios.get(`${process.env.REACT_APP_API}/v1/challenges`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Token: ${tokenStr}`,
    },
  });
  return res.data.challenges;
};
